module.exports = __webpack_public_path__ + "img/pashik_gonbad.26a16e52.png";